// import React, { useState, useEffect, useContext } from "react";
// import { Link } from "react-router-dom";
// import { Button, WindmillContext } from "@windmill/react-ui";
// import { useTranslation } from "react-i18next";
// import Error from "components/form/Error";
// import LabelArea from "components/form/LabelArea";
// import InputLogin from "components/form/InputLogin";
// import useLoginSubmit from "../hooks/useLoginSubmit";
// import axios from "axios";
// import loginImg from "../assets/img/loginScreen.svg";
// import MainLogo from "../assets/img/logo/logo-light.svg";
// import MainLogoDark from "../assets/img/logo/logo-dark.svg";

// const Login = () => {
//   const { t } = useTranslation();
//   const {
//     onSubmit,
//     register,
//     trigger,
//     handleSubmit,
//     errors,
//     loading,
//     setValue,
//   } = useLoginSubmit();
//   const [rememberMe, setRememberMe] = useState(false); // initialize rememberMe with false

//   const loginData = {
//     username: "Chat Panel",
//     password: "Chat@123",
//   };

//   const getAuthKey = async () => {
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/login`,
//         loginData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 200 && response.data.status) {
//         const { key } = response.data;
//         localStorage.setItem("authkey", key);
//       } else {
//         console.error("Login failed:", response.data.message);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     getAuthKey();
//     // Retrieve "Remember Me" state from localStorage
//     const storedRememberMe = localStorage.getItem("rememberMe") === "true";
//     setRememberMe(storedRememberMe);

//     // Retrieve email and password from localStorage if "Remember Me" is selected
//     if (storedRememberMe) {
//       const storedEmail = localStorage.getItem("userEmail");
//       const storedPassword = localStorage.getItem("userPassword");

//       if (storedEmail) {
//         setValue("email", storedEmail); // Set the value for email field
//       }
//       if (storedPassword) {
//         setValue("password", storedPassword); // Set the value for password field
//       }
//     }
//     // eslint-disable-next-line
//   }, [setValue]);

//   const handleRememberMeChange = () => {
//     const newRememberMe = !rememberMe;
//     setRememberMe(newRememberMe);
//     localStorage.setItem("rememberMe", newRememberMe.toString());

//     if (!newRememberMe) {
//       // Clear email and password from localStorage if "Remember Me" is unchecked
//       localStorage.removeItem("userEmail");
//       localStorage.removeItem("userPassword");
//     }
//   };

//   const { mode } = useContext(WindmillContext);

//   return (
//     <>
//       <div className="flex justify-center items-center min-h-screen bg-transparent dark:bg-gray-900">
//         <div className="flex items-center relative flex-col md:flex-row loginPageScreen">
//           <main className="loginMainContent bg-gray-50 dark:bg-gray-800 flex items-center w-full relative rounded-2xl">
//             <div className="p-6" style={{ width: "40%" }}>
//               <figure>
//                 <img
//                   src={mode === "dark" ? MainLogoDark : MainLogo}
//                   alt="Logo"
//                 />
//               </figure>
//               <h1 className="my-4 text-2xl font-semibold text-gray-700 dark:text-gray-200">
//                 Login
//               </h1>
//               <form
//                 onSubmit={handleSubmit((data) => onSubmit(data, rememberMe))}
//               >
//                 <LabelArea label="Email" />
//                 <InputLogin
//                   register={register}
//                   trigger={trigger}
//                   label="Email"
//                   name="email"
//                   type="email"
//                   placeholder="test@example.com"
//                 />
//                 <Error errorName={errors.email} />
//                 <div className="mt-8"></div>
//                 <LabelArea label="Password" />
//                 <InputLogin
//                   register={register}
//                   // defaultValue=""
//                   trigger={trigger}
//                   label="Password"
//                   name="password"
//                   type="password"
//                   placeholder="***************"
//                 />
//                 <Error errorName={errors.password} />
//                 <div className="mt-8"></div>

//                 <div className="mt-4 flex items-center justify-between">
//                   <label class="custom-checkbox dark:text-gray-300 text-gray-900">
//                     <input
//                       type="checkbox"
//                       id="rememberMe"
//                       className="form-checkbox"
//                       checked={rememberMe} // ensure checked reflects the state
//                       onChange={handleRememberMeChange}
//                     />
//                     <span class="checkmark"></span>

//                     {t("Remember Me")}
//                   </label>

//                   <Link
//                     className="text-sm font-medium text-green-600 hover:underline focus:outline-none"
//                     to="/forgot-password"
//                   >
//                     {t("ForgotPassword")}
//                   </Link>
//                 </div>

//                 <Button
//                   disabled={loading}
//                   type="submit"
//                   className="mt-6 h-12 w-full"
//                   to="/dashboard"
//                 >
//                   {t("LoginTitle")}
//                 </Button>
//               </form>
//             </div>

//             <div className="clip-diagonal flex-1 h-full overflow-hidden loginScreenImg relative">
//               <img
//                 src={loginImg}
//                 className="w-full h-full object-cover"
//                 alt="loginImg"
//               />
//               <div className="absolute inset-0 flex justify-top items-end flex-col pt-8 pr-8">
//                 <h1 className="text-gray-200 text-5xl font-bold">Welcome</h1>
//                 <p className="text-gray-200 text-lg">
//                   Enter your Details and Start Chat with Agents
//                 </p>
//               </div>
//             </div>

//           </main>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Login;




import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Button, WindmillContext } from "@windmill/react-ui";
import { useTranslation } from "react-i18next";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import InputLogin from "components/form/InputLogin";
import useLoginSubmit from "../hooks/useLoginSubmit";
import axios from "axios";
import loginImg from "../assets/img/loginScreen.svg";
import MainLogo from "../assets/img/logo/logo-light.svg";
import MainLogoDark from "../assets/img/logo/logo-dark.svg";

const Login = () => {
  const { t } = useTranslation();

  const {
    onSubmit,
    register,
    trigger,
    handleSubmit,
    errors,
    loading,
    setValue,
  } = useLoginSubmit();

  const [rememberMe, setRememberMe] = useState(false);

  const loginData = {
    username: "Chat Panel",
    password: "Chat@123",
  };

  const getAuthKey = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/login`,
        loginData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data.status) {
        const { key } = response.data;
        localStorage.setItem("authkey", key);
      } else {
        console.error("Login failed:", response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAuthKey();

    const storedRememberMe =
      localStorage.getItem("rememberMe") === "true";

    setRememberMe(storedRememberMe);

    if (storedRememberMe) {
      const storedEmail = localStorage.getItem("userEmail");
      const storedPassword = localStorage.getItem("userPassword");

      if (storedEmail) {
        setValue("email", storedEmail);
      }

      if (storedPassword) {
        setValue("password", storedPassword);
      }
    }
  }, [setValue]);

  const handleRememberMeChange = () => {
    const newRememberMe = !rememberMe;

    setRememberMe(newRememberMe);

    localStorage.setItem(
      "rememberMe",
      newRememberMe.toString()
    );

    if (!newRememberMe) {
      localStorage.removeItem("userEmail");
      localStorage.removeItem("userPassword");
    }
  };

  const { mode } = useContext(WindmillContext);

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-transparent dark:bg-gray-900">
      <div className="flex w-1/2 max-w-6xl items-center justify-center">
        <main className="loginMainContent flex sm:w-2/3 w-full flex-col overflow-hidden rounded-2xl bg-gray-50 shadow-xl dark:bg-gray-800 md:flex-row">
          <div className="flex w-full flex-col justify-center p-5 sm:p-7 md:w-1/2 md:p-8 lg:w-[40%] lg:p-10">
            <figure className="mb-2 w-full max-w-[180px] sm:max-w-[200px]">
              <img
                src={
                  mode === "dark"
                    ? MainLogoDark
                    : MainLogo
                }
                alt="Logo"
                className="h-auto w-full object-contain"
              />
            </figure>

            <h1 className="my-4 text-2xl font-semibold text-gray-700 sm:text-3xl dark:text-gray-200">
              Login
            </h1>

            <form
              className="w-full"
              onSubmit={handleSubmit((data) =>
                onSubmit(data, rememberMe)
              )}
            >
              <LabelArea label="Email" />

              <InputLogin
                register={register}
                trigger={trigger}
                label="Email"
                name="email"
                type="email"
                placeholder="test@example.com"
              />

              <Error errorName={errors.email} />

              <div className="mt-5 sm:mt-7"></div>

              <LabelArea label="Password" />

              <InputLogin
                register={register}
                trigger={trigger}
                label="Password"
                name="password"
                type="password"
                placeholder="***************"
              />

              <Error errorName={errors.password} />

              <div className="mt-5 sm:mt-7"></div>

              <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <label className="custom-checkbox flex min-w-0 cursor-pointer items-center dark:text-gray-300 text-gray-900">
                  <input
                    type="checkbox"
                    id="rememberMe"
                    className="form-checkbox"
                    checked={rememberMe}
                    onChange={handleRememberMeChange}
                  />

                  <span className="checkmark"></span>

                  <span className="ml-2 text-sm">
                    {t("Remember Me")}
                  </span>
                </label>

                <Link
                  className="text-sm font-medium text-green-600 hover:underline focus:outline-none"
                  to="/forgot-password"
                >
                  {t("ForgotPassword")}
                </Link>
              </div>

              <Button
                disabled={loading}
                type="submit"
                className="mt-6 h-12 w-full"
                to="/dashboard"
              >
                {t("LoginTitle")}
              </Button>
            </form>
          </div>

          <div className="loginScreenImg relative hidden min-h-[320px] w-2/3 flex-1 overflow-hidden md:flex md:min-h-[520px] lg:min-h-[600px]">
            <div className="clip-diagonal absolute inset-0">
              <img
                src={loginImg}
                className="h-full w-full object-cover"
                alt="loginImg"
              />
            </div>

            <div className="absolute inset-0 flex flex-col items-end justify-start px-5 pt-8 text-right sm:px-8 md:pt-10 lg:px-10 lg:pt-12">
              <h1 className="text-3xl font-bold text-gray-200 sm:text-4xl lg:text-5xl">
                Welcome
              </h1>

              <p className="mt-2 w-[180px] text-wrap text-sm leading-6 text-gray-200 sm:text-base lg:text-lg">
                Enter your Details and Start Chat with Agents
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Login;

